export const formatValue = (value: any) => {
  const num = Number(value) || 0;
  const rounded = Math.round(num * 100) / 100; 
  const str = rounded.toString();

  return str.includes(".")
    ? str.split(".")[1].length === 1
      ? str + "0"
      : str
    : str + ".00";
};

export const getTotalDeduction = (item:any) => {
  const {
    diamondDeduction = 0,
    goldDeduction = 0,
    laborDeduction = 0,
    storeDeduction = 0,
    rewardDeduction = 0,
    consumerOfferDeduction = 0,
    gstDeduction = 0,
  } = item;

    const total =
    diamondDeduction +
    goldDeduction +
    laborDeduction +
    storeDeduction +
    rewardDeduction +
    consumerOfferDeduction +
    gstDeduction;

  return formatValue(total);
};